import styled, { css } from 'styled-components';
import { sanJuan } from 'components/style/Colors.style';

export const ChartTitle = styled.h6.attrs({
  className: 'font-weight-bold m-0'
})`
  color: ${sanJuan};
  font-size: 14px;
  line-height: normal;
  letter-spacing: 0.6px;

  margin-right: -10px !important;
`;

export const labelLetterSpacing = css`
  letter-spacing: 0.6px;
`;



// WEBPACK FOOTER //
// ./src/components/style/Headings.style.js